import { showErrorNotification } from '@/utils/utils.js';

const state = {
  contract: {},
  isContractLoading: false,
  contractError: null
};

const mutations = {
  setContractLoading(state, isLoading) {
    state.isContractLoading = isLoading;
  },
  setContractError(state, error) {
    state.contractError = error;
  },
  setContract(state, contract) {
    state.contract = contract;
  }
};

const actions = {
  async getOrgContract(context) {
    context.commit('setContractLoading', true);
    context.commit('setContractError', null);

    const orgID = context.rootGetters['org/getCurrentOrgId'];
    const url = `/core/organization/${orgID}/attendee_count/`,
      method = 'GET';
    return context
      .dispatch('makeapicall', { url, method }, { root: true })
      .then(response => {
        context.commit('setContract', response);
      })
      .catch(error => {
        const err = JSON.parse(error);
        context.commit('setContract', {});
        context.commit('setContractError', err);
        if (err?.code !== 'ORGANIZATION_DOES_NOT_HAVE_CONTRACT') {
          const errorMessage = err.message ? err.message : 'Something went wrong! please try again.';
          showErrorNotification(errorMessage);
        }
      })
      .finally(() => {
        context.commit('setContractLoading', false);
      });
  }
};

export default {
  state,
  mutations,
  actions,
  namespaced: true
};
